export function isSemverBelow(current: string, required: string): boolean {
  const parse = (v: string) => v.split('.').map(Number)
  const [cMaj, cMin, cPat] = parse(current)
  const [rMaj, rMin, rPat] = parse(required)
  if (cMaj !== rMaj) return cMaj < rMaj
  if (cMin !== rMin) return cMin < rMin
  return cPat < rPat
}

export function isPbjsVersionBelowRequired(scopePbjsVersion?: string, pbjsMinRequiredVersion?: string): boolean {
  if (!scopePbjsVersion || !pbjsMinRequiredVersion) return false
  return isSemverBelow(scopePbjsVersion, pbjsMinRequiredVersion)
}
